import { APP_WILL_MOUNT, APP_WILL_UNMOUNT } from '../base/app/actionTypes';
import { CONFERENCE_JOINED } from '../base/conference/actionTypes';
import { JitsiConferenceEvents } from '../base/lib-jitsi-meet';
import { setAudioMuted } from '../base/media/actions';
import { MEDIA_TYPE } from '../base/media/constants';
import { raiseHand } from '../base/participants/actions';
import { getLocalParticipant } from '../base/participants/functions';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { playSound, registerSound, unregisterSound } from '../base/sounds/actions';
import { hideNotification, showNotification } from '../notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE } from '../notifications/constants';
import { isForceMuted } from '../participants-pane/functions';
import { isAudioMuteButtonDisabled } from '../toolbox/functions.any';
import { setCurrentNotificationUid } from './actions';
import { TALK_WHILE_MUTED_SOUND_ID } from './constants';
import { TALK_WHILE_MUTED_SOUND_FILE } from './sounds';
MiddlewareRegistry.register(store => next => action => {
    const result = next(action);
    const { dispatch, getState } = store;
    const { conference } = action;
    switch (action.type) {
        case APP_WILL_MOUNT:
            dispatch(registerSound(TALK_WHILE_MUTED_SOUND_ID, TALK_WHILE_MUTED_SOUND_FILE));
            break;
        case APP_WILL_UNMOUNT:
            dispatch(unregisterSound(TALK_WHILE_MUTED_SOUND_ID));
            break;
        case CONFERENCE_JOINED: {
            /* eslint-disable no-console */
            console.log('[TWM] CONFERENCE_JOINED — attaching TALK_WHILE_MUTED / TRACK_MUTE_CHANGED listeners');
            conference.on(JitsiConferenceEvents.TRACK_MUTE_CHANGED, (track) => {
                if (track.isAudioTrack() && track.isLocal()) {
                    console.log('[TWM] TRACK_MUTE_CHANGED local audio, muted =', track.isMuted());
                    // When muted, VADTalkMutedDetection should START the emitter.
                    setTimeout(() => probe('after-mute'), 700);
                }
                const { currentNotificationUid } = getState()['features/talk-while-muted'];
                if (currentNotificationUid && track.isAudioTrack() && track.isLocal() && !track.isMuted()) {
                    dispatch(hideNotification(currentNotificationUid));
                    dispatch(setCurrentNotificationUid());
                }
            });
            conference.on(JitsiConferenceEvents.TALK_WHILE_MUTED, () => {
                console.log('[TWM] >>> TALK_WHILE_MUTED event FIRED (lib detected talk-while-muted)');
                const state = getState();
                const local = getLocalParticipant(state);
                const audioBtnDisabled = isAudioMuteButtonDisabled(state);
                console.log('[TWM] isAudioMuteButtonDisabled =', audioBtnDisabled);
                // Display the talk while muted notification only when the audio button is not disabled.
                if (!isAudioMuteButtonDisabled(state)) {
                    const forceMuted = isForceMuted(local, MEDIA_TYPE.AUDIO, state);
                    const notification = dispatch(showNotification({
                        titleKey: 'toolbar.talkWhileMutedPopup',
                        customActionNameKey: [forceMuted ? 'notify.raiseHandAction' : 'notify.unmute'],
                        customActionHandler: [() => dispatch(forceMuted ? raiseHand(true) : setAudioMuted(false))]
                    }, NOTIFICATION_TIMEOUT_TYPE.LONG));
                    console.log('[TWM] showNotification dispatched — returned uid =', notification && notification.uid);
                    const { soundsTalkWhileMuted } = getState()['features/base/settings'];
                    if (soundsTalkWhileMuted) {
                        dispatch(playSound(TALK_WHILE_MUTED_SOUND_ID));
                    }
                    if (notification) {
                        // we store the last start muted notification id that we showed,
                        // so we can hide it when unmuted mic is detected
                        dispatch(setCurrentNotificationUid(notification.uid));
                    }
                }
                else {
                    console.log('[TWM] notification SUPPRESSED (audio mute button disabled)');
                }
            });
            // The VAD emitter is only created when a LOCAL AUDIO track is added
            // (VADAudioAnalyser._trackAdded). Log those so we can see if/when the
            // local audio track appears — 0 audio tracks = detection never starts.
            conference.on(JitsiConferenceEvents.TRACK_ADDED, (track) => {
                if (track?.isLocalAudioTrack?.()) {
                    console.log('[TWM] TRACK_ADDED: LOCAL AUDIO track added — device =', track.getDeviceId?.(), '| muted =', track.isMuted?.(), '| hasEffect =', Boolean(track._streamEffect || track.effect));
                    // Did the analyser pick up this track and create the VAD emitter?
                    setTimeout(() => probe('after-track+2s'), 2000);
                }
            });
            // Probe lib-jitsi-meet internals at intervals to confirm the VAD
            // detection was initialized AND that a local audio track exists (the
            // trigger for the VAD emitter).
            const probe = (tag) => {
                const c = conference;
                const audioTracks = (c?.getLocalTracks?.() ?? []).filter((t) => t.isAudioTrack?.());
                console.log(`[TWM] probe@${tag}: _audioAnalyser =`, Boolean(c?._audioAnalyser), '| _vadEmitter =', Boolean(c?._audioAnalyser?._vadEmitter), '| _isVADEmitterRunning =', Boolean(c?._audioAnalyser?._isVADEmitterRunning), '| localAudioTracks =', audioTracks.length, '| muted =', audioTracks.map((t) => t.isMuted?.()));
            };
            setTimeout(() => probe('2.5s'), 2500);
            setTimeout(() => probe('7s'), 7000);
            setTimeout(() => probe('15s'), 15000);
            /* eslint-enable no-console */
            break;
        }
    }
    return result;
});
